

import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import { context } from "../utils";
const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
};
const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center"
};

const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

const multiValueContainer = ({ selectProps, data }) => {

    const label = data.labelRawText || data.label;
    const allSelected = selectProps.value;
    const index = allSelected.findIndex(selected => selected.labelRawText === label || selected.label === label);
    const isLastSelected = index === allSelected.length - 1;
    //const labelSuffix = isLastSelected ? ` (${allSelected.length})` : ", ";
    const labelSuffix = isLastSelected ? `` : ", ";
    const val = `${label}${labelSuffix}`;

    //return allSelected.length > 1 ? (isLastSelected ? "multiple selected" : "") : label;

    return val;
};
const MultiSelectInline = props => {

    //const [state, setState] = useState({ isOpen: false, value: undefined });
    const ref = useRef();
    const [isOpen, setisOpen] = useState(false);
    const toggleOpen = (e) => {
        e.stopPropagation();
        //setState((state) => ({ isOpen: !state.isOpen }));

        setisOpen(x => !x);
    };
    const onSelectChange = (value) => {
        //toggleOpen();

        props.onChange(value);
    };
    const { options } = props;

    const summary = props.value ? props.value.map(x => x.labelRawText || x.label).join(', ') : '';

    const hasImages = props.hasImages;
    useOnClickOutside(ref, () => setisOpen(false));

    const onCleared = (e) => {
        e.stopPropagation();
        setisOpen(false);
        props.onChange([]);
    };

    const isEmpty = !(props.value && props.value.length);

    const isSearchable = props.isSearchable !== undefined ? props.isSearchable : !context.is_mobile;
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#cce0ff' : state.isFocused ? "#DEEBFF" : "initial",
            color: "inherit",
            fontWeight: state.isSelected ? 'bold' : "initial",
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            textOverflow: "ellipsis",
            //maxWidth: "90%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            color: "#222",
            //display: "initial"
        }),
        control: (provided) => ({
            ...provided,
            margin: "8px",
            ...(!isSearchable ? { display: "none" } : {}),
        }),
        menu: (provided) => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    };

    return (
        <div ref={ref}>
            {/* <Select
                    components={{
                        MultiValueContainer: multiValueContainer
                        // Option: CustomOption,
                    }}

                    formatGroupLabel={formatGroupLabel}

                    styles={customStyles}

                    options={options} isMulti value={this.props.value} isClearable={true} onChange={this.props.onChange} /> */}


            <Dropdown
                isOpen={isOpen}
                onClose={toggleOpen}

                className={props.className}
                target={
                    <button
                        type="submit"
                        className="select__control"
                        onClick={toggleOpen}
                        // isSelected={isOpen}
                        style={{ width: "100%", }}
                    >
                        <div className="select__value">
                            <span style={{
                                textOverflow: "ellipsis",
                                //maxWidth: "90%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                //display: "initial"
                                textAlign: "left",
                                color: "#222",
                            }}>
                                {props.value && props.value.length ? summary :
                                    <span className="select__placeholder">{props.placeholder}</span>}
                            </span>
                        </div>
                        <div className="select__indicators">

                            {!isEmpty ?
                                <div className="select__indicator select__clear-indicator" onClick={onCleared}>
                                    <components.CrossIcon />
                                </div>
                                : ''}
                            <div className="select__indicator-separator"></div>
                            <div className="select__indicator">
                                <components.DownChevron />
                            </div>
                        </div>

                    </button>
                }
            >
                <Select
                    options={options}
                    //defaultValue={[optionGroups[0].options[0]]}

                    {...props}

                    isMulti
                    components={{
                        MultiValueContainer: () => { return ""; },

                        DropdownIndicator: null,
                        IndicatorSeparator: null,
                        Option: props => <Option {...props} hasImages={hasImages} />

                    }}
                    formatGroupLabel={formatGroupLabel}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    styles={customStyles}
                    isClearable={false}
                    controlShouldRenderValue={false}

                    autoFocus
                    backspaceRemovesValue={false}
                    menuIsOpen
                    // onChange={onSelectChange}
                    placeholder="Search..."
                    tabSelectsValue={false}
                    formatOptionLabel={props.hasImages ? formatOptionLabelWithImage : null}

                    isSearchable={isSearchable}

                />
            </Dropdown>
        </div>);
};



const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: 4 }}
                />{" "}
                <label>{props.hasImages ? formatOptionLabelWithImage(props.data) : props.data.label}</label>
            </components.Option>
        </div>
    );
};

export const formatOptionLabelWithImage = ({ value, label, image }) => {

    return <div className="myselect-label-container">
        <span className="myselect-label-image" style={image ? { backgroundColor: "#f6f7f9" } : {}}>
            {image ? <img src={image} style={{ height: "100%", maxHeight: "50px" }} /> : ''}
        </span>
        {label}
    </div>;
};


const Menu = props => {
    const shadow = 'hsla(218, 50%, 10%, 0.1)';
    return (
        <div
            style={{
                backgroundColor: 'white',
                borderRadius: 4,
                boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
                marginTop: 8,
                position: 'absolute',
                zIndex: 2,
                width: "100%",
            }}
            {...props}
        />
    );
};
const Blanket = props => (
    <div
        style={{
            bottom: 0,
            left: 0,
            top: 0,
            right: 0,
            position: 'fixed',
            zIndex: 1,
        }}
        {...props}
    />
);

const Dropdown = ({
    children,
    isOpen,
    target,
    onClose,
    ...rest
}) => (
    <div {...rest} style={{ position: 'relative' }}>
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {/* {isOpen ? <Blanket onClick={onClose} /> : null} */}
    </div>
);

// Hook
function useOnClickOutside(ref, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [ref, handler]
    );
}

export default MultiSelectInline;